import type { MenuCategory } from "./types";
import { sanitizeStoreUrl } from "~/utils/constants";

interface NavigationCategoriesProps {
  categories: MenuCategory[];
  borderRight?: boolean;
}

function NavigationCategories({
  categories,
  borderRight,
}: NavigationCategoriesProps) {
  return (
    <>
      {categories.map((category, index) => (
        <div
          className={`flex flex-col w-full max-w-max px-0 ${
            index === 0 ||
              borderRight && index === 1 && categories.length > 1
              ? "border-r border-solid border-[#DBDBDB] pr-[76px]"
              : ""
          }`}
        >
          <h3 className="font-['Poppins'] not-italic font-bold text-lg leading-[24px] tracking-[0.06em] text-[#333333] mt-2 mb-4 mx-0 capitalize">
            <a className="!text-[#000000]" href={sanitizeStoreUrl(category.url)}>
              {category.name}
            </a>
          </h3>
          <div
            className="grid w-full gap-x-10 2xl:gap-x-28 gap-y-3"
            style={{
              gridAutoFlow: "column",
              gridTemplateRows: `repeat(${
                Math.min(8, category.subcategories.length)
              }, auto)`,
            }}
          >
            {category.subcategories.map((subcategory) => {
              const isSeeAll = subcategory.name.trim().toLowerCase() ===
                "ver tudo";
              return (
                <h4
                  className={`font-['Poppins'] not-italic text-sm leading-[35px] tracking-[0.06em] text-[#333333] mx-0 ${
                    subcategory.highlight ? "font-semibold" : "font-normal"
                  }`}
                >
                  <a
                    className={`!text-[#000000] hover:border-b-[1px] hover:border-b-[#434343] border-b-[1px] ${
                      isSeeAll ? "border-b-[#000000]" : "border-b-transparent"
                    }`}
                    href={sanitizeStoreUrl(subcategory.url)}
                  >
                    {subcategory.name}
                  </a>
                </h4>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
}

export default NavigationCategories;

